import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, reduxForm, SubmissionError, formValueSelector } from 'redux-form';
import Fa from 'react-fontawesome';
import { trim, find } from 'lodash';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import Joi from 'joi';
import DateTimeDisplay from '../../../../components/date-time-display';
import { getFeedbackRequestSettings } from '../../../Dashboard/DashboardReducer';

class CancelOutreachForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.props.initialize({ reason: null });
    }
  }

  close() {
    this.props.onClose(this.props.contact);
  }

  handleSubmit(data) {
    const p = this.props.onRequestCancel(this.props.contact, data);
    return p.then(
      (r) => {
        this.props.onClose(this.props.contact);
      },
      (errors) => {
        const e = errors.data || errors;
        if (e.message) {
          e._error = e.message;
        }
        throw new SubmissionError(e);
      },
    );
  }

  renderField({
    input, label, componentClass, placeholder, options, className, meta: { touched, error },
  }) {
    const { submitting } = this.props;

    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup className={className} validationState={validationState}>
        {label !== null && label !== undefined && <ControlLabel>{label}</ControlLabel>}
        {componentClass !== 'select' &&
          <FormControl
            {...input}
            componentClass={componentClass}
            placeholder={placeholder}
            disabled={submitting}
          />
        }
        {componentClass === 'select' &&
          <FormControl
            {...input}
            componentClass={componentClass}
            disabled={submitting}
          >
            <option value="">please select an exclusion reason</option>
            {options.map(o => (<option key={o._id} value={o._id}>{o.label}</option>))}
          </FormControl>
        }
        {error && touched && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  renderForm() {
    const {
      handleSubmit, submitting, show, valid,
      error, reasons,
      otherReasonId, selectReasonId, isModal,
    } = this.props;


    if (!reasons || reasons.length === 0) {
      return (
        <div>
          <Modal.Body>
            <div className="alert alert-danger">No exclusion reasons found.</div>
          </Modal.Body>
          {isModal &&
            <Modal.Footer>
              <div className="clearfix">
                <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.close}>Do not cancel</Button>
              </div>
            </Modal.Footer>
          }
        </div>
      );
    }

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Modal.Body>
          {error && <div className="alert alert-danger">{error}</div>}
          <Field
            name="reason_id"
            label="Cancel Reason:"
            componentClass="select"
            options={reasons}
            component={this.renderField}
          />
          {otherReasonId !== null && otherReasonId === selectReasonId &&
            <Field
              name="reason"
              placeholder="Please provide cancel reason:"
              componentClass="textarea"
              component={this.renderField}
            />
          }
        </Modal.Body>
        <Modal.Footer>
          {isModal && 
            <div className="clearfix">
              <Button className="pull-left" bsStyle="link" disabled={submitting} onClick={this.close}>Do not cancel</Button>
              <Button className="pull-right" bsStyle="danger" disabled={submitting || !valid} type="submit">
                {!submitting && <span>Cancel All Feedback Requests</span>}
                {submitting && <span><Fa name="spinner" spin /></span>}
              </Button>
            </div>
          }
          {!isModal &&
            <div className="text-center">
              <Button bsStyle="danger" disabled={submitting || !valid} type="submit">
                {!submitting && <span>Cancel All Feedback Requests</span>}
                {submitting && <span><Fa name="spinner" spin /></span>}
              </Button>
            </div>
          }
        </Modal.Footer>
      </form>
    );
  }



  renderModal() {
    const { show, contact } = this.props;
    return (
      <Modal show={show} onExited={this.close}>
        <Modal.Header>
          <Modal.Title>Cancel outreach for {contact.first_name} {contact.last_name}</Modal.Title>
        </Modal.Header>
        {this.renderForm()}
      </Modal>
    );
  }

  renderTerminatedModal() {
    const {
      show,
      contact,
    } = this.props;
    const hasReason = trim(contact.terminated_reason).length > 0;

    return (
      <Modal show={show} onExited={this.close}>
        <Modal.Header>
          <Modal.Title>Cancel outreach for {contact.first_name} {contact.last_name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="text-center">
              <div>Outreach terminated on <strong><DateTimeDisplay value={contact.last_contact_status_updated} /></strong></div>
              {hasReason &&
                <div>
                  <strong>Reason:</strong> {contact.terminated_reason}
                </div>
              }
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button className="pull-right" bsStyle="link" onClick={this.close}>Done</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }



  render() {
    const {
      isModal, contact,
    } = this.props;
    const isTerminated = contact !== null && contact.contact_status === 'TERMINATED';
    if (isTerminated) {
      return this.renderTerminatedModal();
    }
    if (isModal) {
      return this.renderModal();
    }
    return this.renderForm();
  }
}

CancelOutreachForm.propTypes = {
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  valid: PropTypes.bool.isRequired,
  contact: PropTypes.shape({}).isRequired,
  onRequestCancel: PropTypes.func,
  isModal: PropTypes.bool,
  reasons: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
  })),
  selectReasonId: PropTypes.string,
  otherReasonId: PropTypes.string,
  error: PropTypes.string,
};
CancelOutreachForm.defaultProps = {
  show: false,
  onClose: () => {},
  onRequestCancel: () => {},
  isModal: true,
  reasons: [],
  selectReasonId: null,
  otherReasonId: null,
  error: null,
};

const validate = (data, props) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   reason_id: {
  //     type: 'string',
  //     presence: { allowEmpty: false },
  //   },
  //   ...(props.otherReasonId && props.otherReasonId === props.selectReasonId ? {
  //     reason: {
  //       presence: { allowEmpty: false },
  //       length: {
  //         minimum: 10,
  //         maximum: 2048,
  //       },
  //     },
  //   } : {}),
  // };

  const schemaFields = {
    reason_id: Joi.string().required().messages({
      'string.base': 'Reason is required',
      'string.empty': 'Reason is required',
      'any.required': 'Reason is required',
    }),
  };

  if (props.otherReasonId && props.otherReasonId === props.selectReasonId) {
    schemaFields.reason = Joi.string().min(10).max(2048).required().messages({
      'string.base': 'Other reason must be a string',
      'string.empty': 'Other reason is required',
      'any.required': 'Other reason is required',
      'string.min': 'Other reason must be at least 10 characters',
      'string.max': 'Other reason must be at most 2048 characters',
    });
  }

  const schema = Joi.object(schemaFields).unknown(true);
  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};
const selector = formValueSelector('cancelOutreachForm');

function mapStateToProps(state) {
  const feedbackRequestSettings = getFeedbackRequestSettings(state);
  const reasons = feedbackRequestSettings?.exclusion_reasons || [];
  const otherReason = find(reasons, { type: 'OTHER' });
  const otherReasonId = otherReason ? otherReason._id : null;

  return {
    reasons,
    selectReasonId: selector(state, 'reason_id'),
    otherReasonId,
  };
}
const CancelModalForm = reduxForm({
  form: 'cancelOutreachForm',
  validate,
})(CancelOutreachForm);

export default connect(mapStateToProps)(CancelModalForm);
